import { FiCheck, FiClock, FiActivity } from "react-icons/fi";
import type { FinalMemberStatus } from "../../../../../types/panel.type";

/**
 * Final-scoring is a distinct pass from the initial submission, so these labels
 * are explicit about the *final* scores. A bare "Pending" was being read as
 * "hasn't scored at all" when the member had in fact submitted initial scores
 * (PRO-500).
 */

export const getFinalStatusIcon = (status: FinalMemberStatus): React.ReactNode => {
	switch (status) {
		case "submitted":
			return <FiCheck size={12} aria-hidden="true" />;
		case "in_progress":
			return <FiActivity size={12} aria-hidden="true" />;
		default:
			return <FiClock size={12} aria-hidden="true" />;
	}
};

export const getFinalStatusBadgeClasses = (status: FinalMemberStatus): string => {
	switch (status) {
		case "submitted":
			return "bg-green-100 text-green-700";
		case "in_progress":
			return "bg-[#e8eeff] text-[#0031DD]";
		default:
			return "bg-gray-100 text-gray-600";
	}
};

export const getFinalStatusLabel = (status: FinalMemberStatus): string => {
	switch (status) {
		case "submitted":
			return "Final scores submitted";
		case "in_progress":
			return "Final scores in progress";
		default:
			return "Awaiting final scores";
	}
};
